import { Box, Typography } from '@mui/material'
import { LandingButton } from 'components'
import { COLORS } from 'const'
import { landingButtonPrimary, normalTextStyle } from 'styles'

type Props = {
  title: string
  description: string[]
  image: string
  buttonText: string
  buttonTextAlt: string
  onClick: () => void
  onClickAlt?: () => void
}

export const ServiceCard = ({
  title,
  description,
  image,
  buttonText,
  buttonTextAlt,
  onClick,
  onClickAlt,
}: Props) => {
  return (
    <Box
      sx={{
        borderRadius: { xs: '20px', lg: '40px' },
        overflow: 'hidden',
        width: { xs: '100%', lg: 550, xl: 400 },
        maxWidth: 275,
        minWidth: 275,
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        boxShadow: 3,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: '415px',
        height: '415px',
        border: '1px solid #E4E4E4',
      }}
    >
      <Box
        sx={{
          background:
            'linear-gradient(180deg, rgba(0, 0, 0, 0.9) 0%, rgba(25, 27, 30, 0.7) 50%, rgba(25, 27, 30, 0.3) 80%, rgba(25, 27, 30, 0) 100%)',
          color: 'white',
          px: 3,
          pt: 3,
          pb: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          flexGrow: 1,
        }}
      >
        <Box>
          {/* Título */}
          <Box
            sx={{
              backgroundColor: '#E4F183',

              borderRadius: { xs: '10px', lg: '20px' },
              px: 2,
              py: 1,
              mb: 2,
              textAlign: 'center',
              fontFamily: 'Work Sans',
              fontSize: 16,
            }}
          >
            <Typography sx={{ ...normalTextStyle, color: COLORS.text.black, fontWeight: 'bold' }}>
              {title}
            </Typography>
          </Box>

          {/* Descripción */}

          <Box component={'ul'} sx={{ gap: 1 }}>
            {description.map((desc) => (
              <Box
                component={'li'}
                key={desc}
                sx={{
                  fontFamily: 'Work Sans',
                  fontWeight: 400,
                  color: 'white',
                  textAlign: 'left',
                  py: 1,
                }}
              >
                {desc}
              </Box>
            ))}
          </Box>
        </Box>

        {/* Botón */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <LandingButton
            text={buttonTextAlt}
            style={{
              ...landingButtonPrimary,
              backgroundColor: '#b5d5ffff',
              color: COLORS.text.black,
              width: '100%',
              borderRadius: '30px',
              flex: 1,
            }}
            onClick={onClickAlt}
          />
          <LandingButton
            text={buttonText}
            style={{
              ...landingButtonPrimary,
              width: '100%',
              borderRadius: '30px',
              flex: 1,
            }}
            onClick={onClick}
          />
        </Box>
      </Box>
    </Box>
  )
}
